// extracted by mini-css-extract-plugin
module.exports = {"Content":"JobsContainer_Content__2ztpP"};